import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import moment from "moment";
import {
  Button,
  IconButton,
  Chip,
  Box,
  Typography,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import { isEmpty } from "../../../lib/utils";
import COVID19QNA from "../../../components/templates/COVID19/COVID19QNA";

import session from "../../../lib/sessionStorage";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "10px",
  },
  section: {
    marginTop: "30px",
    padding: "20px 0",
    lineHeight: 1.6,
    borderTop: "1px solid #333",
    "& p": {
      marginTop: "10px",
    },
    "& > ol > li": {
      marginTop: "20px",
      padding: "0 20px",
    },
  },
  title: {
    padding: "15px 0",
    fontSize: "20px",
    fontWeight: 700,
    textAlign: "center",
  },
  alignCenter: {
    textAlign: "center",
  },
  alignRight: {
    textAlign: "right",
  },
  big: {
    fontSize: "30px",
  },
  bold: {
    fontWeight: 700,
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-around",
    maxWidth: "300px",
  },
  wrapBtn: {
    padding: "10px",
    textAlign: "right",
  },
  download: {
    display: "block",
    color: "#333",
    textAlign: "right",
  },
  userListContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    border: "1px solid #e0e0e0",
    borderRadius: theme.spacing(1),
  },
  userInputRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  userChip: {
    margin: theme.spacing(0.5),
  },
  bulkInputContainer: {
    marginTop: theme.spacing(2),
  },
}));

const COVID19WriteContainer = ({ data, applyChecker }) => {
  const classes = useStyles();
  const [userName, setUserName] = useState("");
  const [userList, setUserList] = useState([]);
  const [currentUserInput, setCurrentUserInput] = useState("");
  const [bulkUserInput, setBulkUserInput] = useState("");
  const [isBulkMode, setIsBulkMode] = useState(false);
  const [isMultipleMode, setIsMultipleMode] = useState(false);
  const [date, setDate] = useState(moment().format("LL"));
  const [apply, setApply] = useState(false);

  useEffect(() => {
    setApply(false);
    applyChecker(false);
  }, [userName, date, userList]);

  // 대상자 추가 함수
  const addUser = (inputValue = currentUserInput) => {
    const trimmedValue = inputValue.trim();
    if (trimmedValue && !userList.includes(trimmedValue)) {
      setUserList((prevList) => [...prevList, trimmedValue]);
      setCurrentUserInput("");
    }
  };

  // 대상자 삭제 함수
  const removeUser = (userToRemove) => {
    setUserList(userList.filter((user) => user !== userToRemove));
  };

  // 일괄 입력 처리 함수
  const handleBulkAdd = () => {
    const names = bulkUserInput
      .split(/[,\n]/)
      .map((name) => name.trim())
      .filter((name) => name && !userList.includes(name));

    setUserList([...userList, ...names]);
    setBulkUserInput("");
    setIsBulkMode(false);
  };

  // 모드 전환 함수
  const handleModeSwitch = (event) => {
    const newMode = event.target.checked;
    setIsMultipleMode(newMode);

    // 다중 모드에서 단일 모드로 전환 시 초기화
    if (!newMode) {
      setUserList([]);
      setCurrentUserInput("");
      setBulkUserInput("");
      setIsBulkMode(false);
    }
  };

  const onApply = () => {
    let el = document.querySelectorAll("[name=text-field]");
    let el_arr = [...el];
    let checker = false;

    el_arr.some((v, i) => {
      if (isEmpty(v.value)) {
        checker = false;
        v.focus();
        return true;
      } else {
        checker = true;
      }
    });

    // 대상자 목록 확인 (모드에 따라 다르게 처리)
    let targetUsers;
    if (isMultipleMode) {
      targetUsers = userList;
      if (targetUsers.length === 0) {
        alert("다중 모드에서는 최소 1명 이상의 대상자를 추가해주세요.");
        return false;
      }
    } else {
      targetUsers = [userName];
      if (isEmpty(userName)) {
        alert("대상자 이름을 입력해주세요.");
        return false;
      }
    }

    if (checker) {
      let _6th = [
        {
          question:
            "현재 37.5℃ 이상의 발열, 기침, 목아픔 등의 증상이 있습니까?",
          answer: 0,
        },
        {
          question:
            "현재 질병관리본부, 코로나 중앙관리대책본부 등에서 연락 받은 관리대상자입니까?",
          answer: 0,
        },
        {
          question: "현재 코로나-19에 대한 능동적 감시대상자입니까?",
          answer: 0,
        },
        {
          question:
            "지난 4월 24일 ~ 5월 10일 중 서울 이태원 지역의 클럽, 식당 등의 사업장 방문자이거나, 방문자의 가족 혹은 밀접접촉자 입니까?",
          answer: 0,
        },
        {
          question:
            "지난 4월 24일 ~ 5월 10일 중 서울 홍대/신촌 지역의 클럽, 식당 등의 사업장 방문자이거나, 방문자의 가족 혹은 밀접접촉자 입니까?",
          answer: 0,
        },
        {
          question: "현재까지 발표된 확진자와 동선이 겹치는 경우가 있습니까?",
          answer: 0,
        },
      ];

      let _7th = [
        {
          question:
            "현재 37.5℃ 이상의 발열, 기침, 목아픔 등의 증상이 있습니까?",
          answer: 0,
        },
        {
          question:
            "현재 질병관리본부, 코로나 중앙관리대책본부 등에서 연락 받은 관리대상자입니까?",
          answer: 0,
        },
        {
          question: "현재 코로나-19에 대한 능동적 감시대상자입니까?",
          answer: 0,
        },
        {
          question: "최근 2주간 집단 발병 감염지역에 방문한 적이 있습니까?",
          answer: 0,
        },
        {
          question:
            "가족 및 동거인이 자가격리대상자 및 능동적감시대상자입니까?",
          answer: 0,
        },
      ];

      // 다중 대상자를 위한 데이터 배열 생성
      let sendDataArray = targetUsers.map((user) => ({
        sign_type: "survey",
        project: "코로나바이러스감염증-19(COVID-19) 관련 사실 확인 여부",
        minor_nm: user,
        round: 7,
        question: _7th,
        user_idx: JSON.parse(session.get("userIdx")),
      }));

      console.log("COVID19 sendDataArray:", sendDataArray);
      console.log("isMultipleMode:", isMultipleMode);

      applyChecker(checker);
      setApply(checker);

      // 단일 모드면 첫 번째 객체만, 다중 모드면 배열 전체 전달
      if (isMultipleMode) {
        data(sendDataArray);
      } else {
        data(sendDataArray[0]);
      }
    }
  };

  return (
    <div className={classes.wrapper}>
      <div>
        <a
          href="/files/코로나사실_확인설문지_5차.docx"
          className={classes.download}
          download
        >
          Word 문서 다운로드
        </a>
        <Table aria-label="table">
          <TableBody>
            <TableRow>
              <TableCell>작성자</TableCell>
              <TableCell>
                <div className={classes.userListContainer}>
                  {/* 모드 전환 스위치 */}
                  <Box mb={2}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isMultipleMode}
                          onChange={handleModeSwitch}
                          color="primary"
                        />
                      }
                      label={
                        <Typography variant="subtitle2">
                          {isMultipleMode ? "다중 작성" : "단일 작성"}
                          {isMultipleMode && ` (${userList.length}명)`}
                        </Typography>
                      }
                    />
                  </Box>

                  {/* 단일 대상자 모드 */}
                  {!isMultipleMode && (
                    <TextField
                      label="작성자 이름"
                      name="text-field"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                      fullWidth
                      placeholder="예: 홍길동"
                    />
                  )}

                  {/* 다중 대상자 모드 */}
                  {isMultipleMode && (
                    <>
                      {/* 개별 추가 */}
                      <div className={classes.userInputRow}>
                        <TextField
                          label="대상자 이름 추가"
                          value={currentUserInput}
                          onChange={(e) => setCurrentUserInput(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              addUser(e.target.value);
                            }
                          }}
                          size="small"
                          style={{ flex: 1 }}
                          placeholder="이름 입력 후 Enter 또는 + 버튼"
                        />
                        <IconButton
                          onClick={() => addUser(currentUserInput)}
                          color="primary"
                          disabled={!currentUserInput.trim()}
                          title="대상자 추가"
                        >
                          <AddIcon />
                        </IconButton>
                        <Button
                          size="small"
                          onClick={() => setIsBulkMode(!isBulkMode)}
                          variant="outlined"
                        >
                          {isBulkMode ? "개별입력" : "일괄입력"}
                        </Button>
                      </div>

                      {/* 일괄 입력 모드 */}
                      {isBulkMode && (
                        <div className={classes.bulkInputContainer}>
                          <TextField
                            label="여러 이름을 쉼표(,) 또는 줄바꿈으로 구분하여 입력"
                            multiline
                            rows={4}
                            value={bulkUserInput}
                            onChange={(e) => setBulkUserInput(e.target.value)}
                            fullWidth
                            placeholder="홍길동, 김철수, 이영희&#10;또는&#10;홍길동&#10;김철수&#10;이영희"
                          />
                          <Box mt={1}>
                            <Button
                              onClick={handleBulkAdd}
                              color="primary"
                              variant="contained"
                              size="small"
                              style={{ marginRight: 8 }}
                            >
                              추가
                            </Button>
                            <Button
                              onClick={() => {
                                setIsBulkMode(false);
                                setBulkUserInput("");
                              }}
                              size="small"
                            >
                              취소
                            </Button>
                          </Box>
                        </div>
                      )}

                      {/* 추가된 대상자 목록 */}
                      {userList.length > 0 && (
                        <Box mt={2}>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            gutterBottom
                          >
                            추가된 대상자:
                          </Typography>
                          <Box>
                            {userList.map((user, index) => (
                              <Chip
                                key={index}
                                label={user}
                                onDelete={() => removeUser(user)}
                                className={classes.userChip}
                                color="primary"
                                variant="outlined"
                              />
                            ))}
                          </Box>
                        </Box>
                      )}
                    </>
                  )}
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <div className={classes.wrapBtn}>
          <Button
            variant="contained"
            color="primary"
            disabled={apply}
            startIcon={<CreateIcon />}
            onClick={onApply}
          >
            Apply
          </Button>
        </div>
      </div>
      {<COVID19QNA mode="write" userName={userName} date={date} />}
    </div>
  );
};

export default COVID19WriteContainer;
